import i18next from 'i18next'
import { List } from 'immutable'
import { HttpResult } from 'widgets-for-react'
import { cmsPageUrlSimpler } from '../../utils/cmsPageUrl'
import { SharepointPageData } from '../cmsPage/sharepointPageApi/types/pageData'
import { HeaderItem } from './headerState'

type HeaderData = {
  NavigationItem: {
    Title: string
  }
  Children: {
    NavigationItem: {
      Title: string
      InternalLink: {
        Path: string
        ContentType: SharepointPageData['ContentType']
      } | null
      ExternalLink: {
        Title: string
        Url: string
      }
    }
  }[]
}[]

export const headerApi = async (): Promise<HttpResult<List<HeaderItem>>> => {
  const res = await fetch(`/api/v1/navigation/${i18next.language}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: HeaderData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: List(
      data.map((item) => ({
        opened: false,
        title: item.NavigationItem.Title,
        children: item.Children.map((child) =>
          child.NavigationItem.InternalLink
            ? {
                title: child.NavigationItem.Title,
                url: cmsPageUrlSimpler(child.NavigationItem.InternalLink),
              }
            : {
                title: child.NavigationItem.Title,
                url: child.NavigationItem.ExternalLink.Url,
              }
        ),
      }))
    ),
  }
}
